export const addSeconds = (date: Date, seconds: number) => {
    date.setSeconds(date.getSeconds() + seconds);
    return date;
};

export const sleep = (milliseconds: number) => {
    return new Promise((resolve) => {
        setTimeout(resolve, milliseconds);
    });
};